// JsFromRoutes CacheKey 7e8809fb52b2b051784206337da01844
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  reconciliation: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/payouts/reconciliation'),
  refresh: /* #__PURE__ */ definePathHelper('post', '/api/workspace/:venue_slug/payouts/:id/refresh'),
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/payouts'),
  show: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/payouts/:id'),
}
